/**
 * @desc 获取设置信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 基地id */
  baseId?: number;
  /** 类型（0是全局设置，1是基地设置） */
  type?: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.QuerySettingResponse>> {
  return defHttp.get({
    url: '/web/setting/listSettings',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.QuerySettingResponse>> {
  return defHttp.get({
    url: '/mock/web/setting/listSettings',

    params,
  });
}
